(() => {
  const PARAM_KEYS = ['rpd_p1', 'rpd_p2', 'rpd_p3', 'rpd_p4', 'rpd_p5'];
  const SECTION_SELECTOR = '[data-featured-collections]';
  const SECTION_READY_EVENT = 'rpd:deferred-section:ready';
  const HYDRATE_IMAGES_EVENT = 'rpd:deferred-card-images:hydrate';

  const getCurrentParams = () => {
    if (window.rpdUrlParams?.current) return window.rpdUrlParams.current;
    const params = new URLSearchParams(window.location.search);
    const values = {};
    PARAM_KEYS.forEach((key) => {
      if (params.has(key)) values[key] = params.get(key);
    });
    return values;
  };

  const normalizeHandles = (value) => {
    if (!value) return [];
    return String(value)
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item);
  };

  const getMainGridHandles = () => {
    const grid = document.querySelector('#product-grid');
    if (!grid) return new Set();
    const handles = new Set();
    grid.querySelectorAll('[data-product-handle]').forEach((item) => {
      const handle = item.dataset.productHandle;
      if (handle) handles.add(handle.toLowerCase());
    });
    return handles;
  };

  const applyDedupe = (node, dedupeHandles) => {
    if (!dedupeHandles || dedupeHandles.size === 0 || !node) return;
    const cards = node.querySelectorAll('[data-product-handle]');
    cards.forEach((card) => {
      const handle = card.dataset.productHandle;
      if (handle && dedupeHandles.has(handle.toLowerCase())) {
        const slide = card.closest('li');
        if (slide) slide.remove();
      }
    });

    const total = node.querySelectorAll('li').length;
    const totalEl = node.querySelector('.slider-counter--total');
    if (totalEl) totalEl.textContent = String(total);
  };

  const buildFetchUrl = (handle, settings, instanceId) => {
    const url = new URL(`/collections/${handle}`, window.location.origin);
    const showViewAllUnder = settings.showViewAll && settings.viewAllPosition === 'under';
    url.searchParams.set('section_id', 'param-collection-items');
    url.searchParams.set('collection_handle', handle);
    url.searchParams.set('instance_id', instanceId);
    url.searchParams.set('products_to_show', settings.productsToShow);
    url.searchParams.set('columns_desktop', settings.columnsDesktop);
    url.searchParams.set('columns_mobile', settings.columnsMobile);
    url.searchParams.set('swipe_on_mobile', settings.swipeOnMobile);
    url.searchParams.set('enable_desktop_slider', settings.enableDesktopSlider);
    url.searchParams.set('image_ratio', settings.imageRatio);
    url.searchParams.set('image_shape', settings.imageShape);
    url.searchParams.set('quick_add', settings.quickAdd);
    url.searchParams.set('quick_add_button_placement', settings.quickAddButtonPlacement);
    url.searchParams.set('quick_add_button_display', settings.quickAddButtonDisplay);
    url.searchParams.set('quick_add_button_icon', settings.quickAddButtonIcon);
    url.searchParams.set('quick_add_button_style', settings.quickAddButtonStyle);
    url.searchParams.set('quick_add_button_width', settings.quickAddButtonWidth);
    url.searchParams.set('show_quick_add_on_desktop', settings.showQuickAddOnDesktop);
    url.searchParams.set('show_quick_add_on_mobile', settings.showQuickAddOnMobile);
    url.searchParams.set('use_selected_variant_for_quick_add', settings.useSelectedVariantForQuickAdd);
    url.searchParams.set('swatch_type', settings.swatchType);
    url.searchParams.set('swatch_ratio', settings.swatchRatio);
    url.searchParams.set('swatch_per_row', settings.swatchPerRow);
    url.searchParams.set('swatch_max', settings.swatchMax);
    url.searchParams.set('show_secondary_image', settings.showSecondaryImage);
    url.searchParams.set('show_vendor', settings.showVendor);
    url.searchParams.set('show_rating', settings.showRating);
    url.searchParams.set('show_view_all', showViewAllUnder);
    url.searchParams.set('view_all_label', settings.viewAllLabel);
    return url.toString();
  };

  const parseCollectionResponse = async (response) => {
    if (!response.ok) return null;
    const text = await response.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');
    return doc.querySelector('[data-param-collection-items]');
  };

  const getSectionSettings = (section) => ({
    productsToShow: section.dataset.productsToShow || '4',
    columnsDesktop: section.dataset.columnsDesktop || '4',
    columnsMobile: section.dataset.columnsMobile || '2',
    swipeOnMobile: section.dataset.swipeOnMobile === 'true',
    enableDesktopSlider: section.dataset.enableDesktopSlider === 'true',
    imageRatio: section.dataset.imageRatio || 'square',
    imageShape: section.dataset.imageShape || 'default',
    quickAdd: section.dataset.quickAdd || 'none',
    quickAddButtonPlacement: section.dataset.quickAddButtonPlacement || 'card_information',
    quickAddButtonDisplay: section.dataset.quickAddButtonDisplay || 'text',
    quickAddButtonIcon: section.dataset.quickAddButtonIcon || 'plus',
    quickAddButtonStyle: section.dataset.quickAddButtonStyle || 'outline',
    quickAddButtonWidth: section.dataset.quickAddButtonWidth || 'full',
    showQuickAddOnDesktop: section.dataset.showQuickAddOnDesktop !== 'false',
    showQuickAddOnMobile: section.dataset.showQuickAddOnMobile !== 'false',
    useSelectedVariantForQuickAdd: section.dataset.useSelectedVariantForQuickAdd === 'true',
    swatchType: section.dataset.swatchType || '',
    swatchRatio: section.dataset.swatchRatio || 'square',
    swatchPerRow: section.dataset.swatchPerRow || '5',
    swatchMax: section.dataset.swatchMax || '6',
    showSecondaryImage: section.dataset.showSecondaryImage === 'true',
    showVendor: section.dataset.showVendor === 'true',
    showRating: section.dataset.showRating === 'true',
    showViewAll: section.dataset.showViewAll === 'true',
    viewAllLabel: section.dataset.viewAllLabel || '',
    showDescription: section.dataset.showDescription === 'true',
    descriptionStyle: section.dataset.descriptionStyle || 'body',
    blockHeadingSize: section.dataset.blockHeadingSize || 'h2',
    viewAllPosition: section.dataset.viewAllPosition || 'under',
    viewAllTitleAlignment: section.dataset.viewAllTitleAlignment || 'left',
    viewAllTitleStyle: section.dataset.viewAllTitleStyle || 'text',
    viewAllTitleButtonText: section.dataset.viewAllTitleButtonText || '',
    viewAllTitleLabel: section.dataset.viewAllTitleLabel || '',
    viewAllTitleIcon: section.dataset.viewAllTitleIcon || 'none',
    viewAllTitleIconSize: section.dataset.viewAllTitleIconSize || '20',
    viewAllTitleWidth: section.dataset.viewAllTitleWidth || 'content',
    viewAllTitleJustify: section.dataset.viewAllTitleJustify || 'flex-start',
    hasManualBlocks: section.dataset.hasManualBlocks === 'true',
  });

  const getNavButtonClass = (style) => {
    if (style === 'nav') return ' button button--nav';
    if (style === 'nav_secondary') return ' button button--nav-secondary';
    return '';
  };

  const createActionSpan = (settings, iconHTML) => {
    if (!settings.viewAllTitleButtonText && (!iconHTML || settings.viewAllTitleIcon === 'none')) return null;
    const action = document.createElement('span');
    action.className = `collection__title-action featured-collections__title-action${getNavButtonClass(
      settings.viewAllTitleStyle
    )}`;
    action.style.setProperty(
      '--featured-collections-title-icon-size',
      `${settings.viewAllTitleIconSize}px`
    );
    if (settings.viewAllTitleButtonText) {
      const text = document.createElement('span');
      text.className = 'collection__title-action-text';
      text.textContent = settings.viewAllTitleButtonText;
      action.appendChild(text);
    }
    if (iconHTML && settings.viewAllTitleIcon !== 'none') {
      const wrapper = document.createElement('span');
      wrapper.innerHTML = iconHTML;
      action.append(...wrapper.childNodes);
    }
    return action;
  };

  const createParamPanel = (section, settings, panelId, displayMode, blockId, iconHTML) => {
    const panel = document.createElement('div');
    panel.className = 'featured-collections__panel';
    panel.dataset.featuredCollectionsPanel = '';
    panel.dataset.panelId = panelId;
    panel.dataset.paramPanel = 'true';
    panel.dataset.paramBlockId = blockId;
    panel.dataset.displayMode = displayMode;
    panel.hidden = true;

    const titleWrapper = document.createElement('div');
    titleWrapper.className = 'collection__title title-wrapper title-wrapper--no-top-margin page-width';

    const title = document.createElement('h3');
    title.className = `title inline-richtext ${settings.blockHeadingSize}${
      settings.viewAllPosition === 'title'
        ? ` featured-collections__title-align-${settings.viewAllTitleAlignment}`
        : ''
    }`;

    const titleText = document.createElement('span');
    titleText.className = 'collection__title-text';
    titleText.dataset.featuredCollectionsTitle = 'true';

    const titleLink = document.createElement('a');
    titleLink.className = 'collection__title-link featured-collections__title-link';
    titleLink.dataset.featuredCollectionsTitleLink = 'true';
    titleLink.hidden = true;
    titleLink.style.justifyContent = settings.viewAllTitleJustify;
    if (settings.viewAllTitleWidth === 'full') titleLink.style.width = '100%';

    const linkText = document.createElement('span');
    linkText.className = 'collection__title-text';
    linkText.dataset.featuredCollectionsTitleLinkText = 'true';
    titleLink.appendChild(linkText);

    const action = createActionSpan(settings, iconHTML);
    if (action) titleLink.appendChild(action);

    title.append(titleText, titleLink);
    titleWrapper.appendChild(title);

    if (settings.showDescription) {
      const description = document.createElement('div');
      description.className = `collection__description ${settings.descriptionStyle} rte`;
      description.dataset.featuredCollectionsDescription = 'true';
      description.hidden = true;
      titleWrapper.appendChild(description);
    }

    const target = document.createElement('div');
    target.dataset.featuredCollectionsTarget = 'true';

    panel.append(titleWrapper, target);
    return panel;
  };

  const createParamTab = (section, panelId) => {
    const tabsWrapper = section.querySelector('[data-featured-collections-tabs]');
    const tabsStyle = tabsWrapper?.dataset.tabsStyle;
    const tab = document.createElement('button');
    tab.type = 'button';
    tab.className = `featured-collections__tab${getNavButtonClass(tabsStyle)}`;
    tab.dataset.featuredCollectionsTab = '';
    tab.dataset.panelId = panelId;
    tab.setAttribute('aria-controls', panelId);
    tab.textContent = 'Collection';
    return tab;
  };

  const updateParamPanelContent = (panel, settings, result) => {
    const titleSpan = panel.querySelector('[data-featured-collections-title]');
    const titleLink = panel.querySelector('[data-featured-collections-title-link]');
    const titleLinkText = panel.querySelector('[data-featured-collections-title-link-text]');
    const description = panel.querySelector('[data-featured-collections-description]');

    const collectionTitle = result.title || '';
    const titleLabel = settings.viewAllTitleLabel || collectionTitle;

    if (titleSpan) titleSpan.textContent = collectionTitle;
    if (titleLinkText) titleLinkText.textContent = titleLabel;

    if (titleLink) {
      titleLink.href = result.url || '';
      titleLink.setAttribute('aria-label', collectionTitle);
    }

    const showTitleLink =
      settings.viewAllPosition === 'title' && settings.showViewAll && result.hasMore === true;

    if (titleLink) titleLink.hidden = !showTitleLink;
    if (titleSpan) titleSpan.hidden = showTitleLink;

    if (description) {
      if (settings.showDescription && result.description) {
        description.innerHTML = result.description;
        description.hidden = false;
      } else {
        description.innerHTML = '';
        description.hidden = true;
      }
    }
  };

  const loadParamPanel = async (handle, panel, settings, iconHTML, dedupeHandles) => {
    const target = panel.querySelector('[data-featured-collections-target]');
    const url = buildFetchUrl(handle, settings, panel.dataset.panelId);
    const response = await fetch(url, { credentials: 'same-origin' });
    const node = await parseCollectionResponse(response);
    if (!node) {
      panel.hidden = true;
      return null;
    }

    applyDedupe(node, dedupeHandles);

    const hasItems = node.querySelectorAll('li').length > 0;
    const isEmpty = node.dataset.collectionEmpty === 'true' || !hasItems;
    target.innerHTML = node.innerHTML;

    const titleWrapper = panel.querySelector('.collection__title');
    if (titleWrapper) {
      if (target.querySelector('.slider--tablet')) {
        titleWrapper.classList.add('title-wrapper--self-padded-tablet-down');
      }
      if (target.querySelector('.slider--desktop')) {
        titleWrapper.classList.add('collection__title--desktop-slider');
      }
    }

    if (isEmpty) {
      panel.hidden = true;
      return { empty: true };
    }

    const result = {
      empty: false,
      title: node.dataset.collectionTitle || '',
      description: node.dataset.collectionDescription || '',
      url: node.dataset.collectionUrl || '',
      handle: node.dataset.collectionHandle || handle,
      hasMore: node.dataset.collectionHasMore === 'true',
    };

    updateParamPanelContent(panel, settings, result, iconHTML);
    panel.hidden = false;
    return result;
  };

  const injectParamCollections = async (section) => {
    const panelSlots = Array.from(section.querySelectorAll('[data-featured-collections-param-panels]'));
    if (!panelSlots.length) return;

    const settings = getSectionSettings(section);
    const params = getCurrentParams();
    const iconTemplate = section.querySelector('[data-featured-collections-title-icon]');
    const iconHTML = iconTemplate ? iconTemplate.innerHTML.trim() : '';
    const dedupeHandles = settings.dedupeMainGrid ? getMainGridHandles() : new Set();
    const tabSlots = Array.from(section.querySelectorAll('[data-featured-collections-param-tabs]'));
    const tabSlotsByBlock = new Map(tabSlots.map((slot) => [slot.dataset.blockId, slot]));
    const tasks = [];

    panelSlots.forEach((slot) => {
      const paramKey = slot.dataset.paramKey;
      const displayMode = slot.dataset.displayMode || 'always';
      const blockId = slot.dataset.blockId || 'param';
      const handles = paramKey ? normalizeHandles(params[paramKey]) : [];
      const tabSlot = tabSlotsByBlock.get(blockId);

      if (!handles.length) {
        if (tabSlot) tabSlot.remove();
        slot.remove();
        return;
      }

      handles.forEach((handle, index) => {
        const panelId = `FeaturedCollections-${section.dataset.sectionId}-param-${blockId}-${index}`;
        const panel = createParamPanel(section, settings, panelId, displayMode, blockId, iconHTML);
        slot.parentNode.insertBefore(panel, slot);

        if (tabSlot) {
          const tab = createParamTab(section, panelId);
          tabSlot.parentNode.insertBefore(tab, tabSlot);
          tasks.push(
            loadParamPanel(handle, panel, settings, iconHTML, dedupeHandles).then((result) => {
              if (result && !result.empty) {
                tab.textContent = result.title || tab.textContent;
              }
            })
          );
        } else {
          tasks.push(loadParamPanel(handle, panel, settings, iconHTML, dedupeHandles));
        }
      });

      if (tabSlot) tabSlot.remove();
      slot.remove();
    });

    await Promise.all(tasks);
  };

  const removeDuplicates = (section, handles) => {
    if (!handles.size) return;
    const cards = section.querySelectorAll('[data-product-handle]');
    cards.forEach((card) => {
      const handle = card.dataset.productHandle;
      if (!handle || !handles.has(handle.toLowerCase())) return;
      const item = card.closest('.grid__item, .slider__slide');
      if (item) item.remove();
    });

    section.querySelectorAll('slider-component').forEach((slider) => {
      if (typeof slider.resetPages === 'function') {
        slider.resetPages();
      }
    });
  };

  const updatePanels = (section) => {
    const panels = Array.from(section.querySelectorAll('[data-featured-collections-panel]'));
    panels.forEach((panel) => {
      const grid = panel.querySelector('[data-featured-collections-grid]');
      if (!grid) {
        panel.hidden = true;
        return;
      }

      const gridType = grid.dataset.featuredCollectionsGridType || 'products';
      const hasItems =
        gridType === 'collections' ? grid.querySelector('li') : grid.querySelector('[data-product-handle]');

      if (!hasItems) {
        panel.hidden = true;
      }
    });
    const visiblePanels = panels.filter((panel) => !panel.hidden);
    if (!visiblePanels.length && !document.documentElement.classList.contains('shopify-design-mode')) {
      section.hidden = true;
    }
    return panels;
  };

  const applyFallbackMode = (section, panels) => {
    const hasManualVisible = panels.some(
      (panel) => panel.dataset.paramPanel !== 'true' && !panel.hidden
    );
    if (!hasManualVisible) return;
    panels.forEach((panel) => {
      if (panel.dataset.paramPanel === 'true' && panel.dataset.displayMode === 'fallback') {
        panel.hidden = true;
      }
    });
  };

  const updateTabs = (section, panels) => {
    const tabsWrapper = section.querySelector('[data-featured-collections-tabs]');
    if (!tabsWrapper) return;

    const tabs = Array.from(section.querySelectorAll('[data-featured-collections-tab]'));
    tabs.forEach((tab) => {
      const panel = panels.find((item) => item.dataset.panelId === tab.dataset.panelId);
      tab.hidden = !panel || panel.hidden;
    });

    const visibleTabs = tabs.filter((tab) => !tab.hidden);
    tabsWrapper.hidden = visibleTabs.length < 2;
  };

  const initTabs = (section, panels) => {
    if (section.dataset.layout !== 'tabs') {
      panels.forEach((panel) => {
        if (!panel.hidden) panel.hidden = false;
      });
      return;
    }

    const tabsWrapper = section.querySelector('[data-featured-collections-tabs]');
    if (!tabsWrapper || tabsWrapper.hidden) {
      panels.forEach((panel) => {
        if (!panel.hidden) panel.hidden = false;
      });
      return;
    }

    const tabs = Array.from(section.querySelectorAll('[data-featured-collections-tab]')).filter(
      (tab) => !tab.hidden
    );
    if (tabs.length < 2) return;

    const panelsById = new Map(panels.map((panel) => [panel.dataset.panelId, panel]));

    tabs.forEach((tab, index) => {
      const panel = panelsById.get(tab.dataset.panelId);
      if (!panel) return;
      if (index === 0) {
        tab.setAttribute('aria-selected', 'true');
        tab.tabIndex = 0;
        panel.hidden = false;
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.tabIndex = -1;
        panel.hidden = true;
      }
    });

    if (!tabsWrapper.dataset.tabsInitialized) {
      tabsWrapper.dataset.tabsInitialized = 'true';
      tabsWrapper.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-featured-collections-tab]');
        if (!tab || tab.hidden) return;
        const panel = panelsById.get(tab.dataset.panelId);
        if (!panel) return;

        tabs.forEach((item) => {
          const isActive = item === tab;
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          item.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((item) => {
          if (item.dataset.panelId === tab.dataset.panelId) {
            item.hidden = false;
            document.dispatchEvent(
              new CustomEvent(HYDRATE_IMAGES_EVENT, {
                detail: { scope: item },
              })
            );
          } else if (!item.hidden) {
            item.hidden = true;
          }
        });
      });
    }
  };

  const initSection = async (section) => {
    await injectParamCollections(section);

    if (section.dataset.dedupeMainGrid === 'true') {
      const handles = getMainGridHandles();
      removeDuplicates(section, handles);
    }

    let panels = updatePanels(section);
    applyFallbackMode(section, panels);
    panels = updatePanels(section);
    updateTabs(section, panels);
    initTabs(section, panels);
  };

  const scheduleInit = (section) => {
    if (!section || section.dataset.featuredCollectionsInitScheduled === 'true') return;
    section.dataset.featuredCollectionsInitScheduled = 'true';

    const run = () => {
      if (section.dataset.featuredCollectionsInitialized === 'true') return;
      section.dataset.featuredCollectionsInitialized = 'true';
      initSection(section);
    };

    if (
      section.dataset.deferredSectionReady === 'true' ||
      !section.hasAttribute('data-deferred-section') ||
      (window.Shopify && window.Shopify.designMode)
    ) {
      run();
      return;
    }

    section.addEventListener(SECTION_READY_EVENT, run, { once: true });
  };

  const init = (scope) => {
    const sections = [];
    if (scope.matches?.(SECTION_SELECTOR)) {
      sections.push(scope);
    }
    const nestedSections = scope.querySelectorAll?.(SECTION_SELECTOR) || [];
    sections.push(...nestedSections);
    if (!sections.length) return;
    sections.forEach((section) => {
      scheduleInit(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target) return;
    init(event.target);
  });
})();
